import React from 'react';

export const NewspaperImg = () => (
  <svg
    width="100%"
    height="112"
    viewBox="0 0 128 112"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M114 0H38C30.275 0 24 6.2825 24 14V94C24 97.305 21.3075 100 18 100C14.6925 100 12 97.3 12 94V20C12 16.6875 9.3125 14 6 14C2.6875 14 0 16.6875 0 20V94C0 103.925 8.075 112 18 112H106C118.132 112 128 102.132 128 90V14C128 6.2825 121.725 0 114 0ZM116 90C116 95.515 111.515 100 106 100H34.975C35.625 98.125 36 96.1 36 94V14C36 12.8985 36.8985 12 38 12H114C115.102 12 116 12.8985 116 14V90ZM66 60H50C46.7 60 44 62.7 44 66C44 69.3 46.7 72 50 72H66C69.325 72 72 69.325 72 66C72 62.675 69.325 60 66 60ZM102 60H86C82.7 60 80 62.7 80 66C80 69.3 82.7 72 86 72H102C105.312 72 108 69.3125 108 66C108 62.6875 105.325 60 102 60ZM66 80H50C46.6875 80 44 82.6875 44 86C44 89.3125 46.6875 92 50 92H66C69.3125 92 72 89.3125 72 86C72 82.6875 69.325 80 66 80ZM102 80H86C82.7 80 80 82.7 80 86C80 89.3 82.6875 92 86 92H102C105.312 92 108 89.3125 108 86C108 82.6875 105.325 80 102 80ZM100 20H52C47.5825 20 44 23.5825 44 28V44C44 48.4175 47.5825 52 52 52H100C104.418 52 108 48.4175 108 44V28C108 23.575 104.425 20 100 20Z"
      fill="#D1D4DC"
    />
  </svg>
);
